// Quick task 260922-mmg: "App Settings" — the Force App Update page.
//
// D-01: no on/off switch of any kind. A platform is active purely by
// having a minimum version or build set — see useAppSettings.js.
import { Alert } from 'react-bootstrap';
import NewInput from 'app/components/NewInput';
import Textarea from 'app/components/Textarea';
import Button from 'app/components/button';
import PageLoader from 'app/components/PageLoader';
import useAppSettings from './useAppSettings';
import './index.scss';

const BUILD_HELPER_TEXT =
  'Only used when the version is blank. To force an update between two builds with the same version name, leave the version empty and set a build number here.';

const WARNING_BANNER_TEXT =
  "Only raise a minimum version once that release is at 100% rollout and confirmed downloadable on that store. A Play Store staged rollout, an App Store phased release or a pending review can lock users out of the app. To undo a block, clear that platform's minimum version and build and save. Blocked users on that platform will get back in the next time they open the app.";

const AppSettings = () => {
  const { values, errors, pageLoading, saving, handleChange, handleSave } = useAppSettings();

  const renderPlatform = (key, heading) => (
    <div className='inner-form-wrapper flex justify-between flex-wrap mb-4'>
      <h5 className='wd-100 mb-3 app-settings__section-title'>{heading}</h5>
      <div className='wd-50'>
        <NewInput
          label='Minimum version'
          id={`${key}_minimum_version`}
          type='text'
          placeholder='e.g. 2.1.5'
          name={`${key}_minimum_version`}
          value={values[`${key}_minimum_version`]}
          onChange={handleChange}
          errorText={errors[`${key}_minimum_version`]}
        />
      </div>
      <div className='wd-50'>
        <NewInput
          label='Minimum build'
          id={`${key}_minimum_build`}
          type='text'
          placeholder='e.g. 181'
          name={`${key}_minimum_build`}
          value={values[`${key}_minimum_build`]}
          onChange={handleChange}
          errorText={errors[`${key}_minimum_build`]}
        />
        <small className='app-settings__helper'>{BUILD_HELPER_TEXT}</small>
      </div>
      <div className='wd-50'>
        <NewInput
          label='Store URL'
          id={`${key}_store_url`}
          type='text'
          name={`${key}_store_url`}
          value={values[`${key}_store_url`]}
          disabled
        />
      </div>
    </div>
  );

  return (
    <div className='blogsForm'>
      <div className='blogsForm_content'>
        <h4 className='app-settings__title'>Force App Update</h4>

        <Alert variant='warning' className='app-settings__warning'>
          {WARNING_BANNER_TEXT}
        </Alert>

        {renderPlatform('android', 'Android')}
        {renderPlatform('ios', 'iOS')}

        <div className='inner-form-wrapper flex justify-between flex-wrap mb-4'>
          <h5 className='wd-100 mb-3 app-settings__section-title'>Dialog copy</h5>
          <div className='wd-50'>
            <NewInput
              label='Title'
              id='title'
              type='text'
              name='title'
              value={values.title}
              onChange={handleChange}
              errorText={errors.title}
            />
          </div>
          <div className='wd-50'>
            <NewInput
              label='Button text'
              id='button_text'
              type='text'
              name='button_text'
              value={values.button_text}
              onChange={handleChange}
              errorText={errors.button_text}
            />
          </div>
          <div className='wd-100'>
            <Textarea
              label='Message'
              id='message'
              name='message'
              rows={3}
              value={values.message}
              onChange={handleChange}
              errorText={errors.message}
            />
          </div>
        </div>

        <div className='d-flex justify-content-start'>
          <Button
            className=''
            onClick={handleSave}
            variant='Save'
            name='Save'
            isDisabled={saving}
          />
        </div>
      </div>
      {pageLoading && <PageLoader pageLoading={pageLoading} />}
    </div>
  );
};

export default AppSettings;
